export default {
  props: {
    isDark: {
      type: Boolean
    }
  },
  data() {
    return {
      array: [{
        url: [require('@/assets/img/partyline.png'), require('@/assets/img/partylineDark.png')],
        label: 'partyline',
        detail: 'partylineDetail'
      }, {
        url: [require('@/assets/img/Galleryview.png'), require('@/assets/img/GalleryviewDark.png')],
        label: 'GalleryView',
        detail: 'GalleryViewDetail'
      }, {
        url: [require('@/assets/img/Conference.png'), require('@/assets/img/ConferenceDark.png')],
        label: 'conference',
        detail: 'conferenceDetail'
      }, {
        url: [require('@/assets/img/Kiosk.png'), require('@/assets/img/KioskDark.png')],
        label: 'kiosk',
        detail: 'kioskDetail'
      }, {
        url: [require('@/assets/img/Globalcontrol.png'), require('@/assets/img/GlobalcontrolDark.png')],
        label: 'globalControl',
        detail: 'globalControlDetail'
      }]
    };
  }
};